import React from "react";
import { twMerge } from "../../../utils";
import { Body } from "../Body";
export var ErrorMessage = function(param) {
    var id = param.id, children = param.children, className = param.className;
    return /*#__PURE__*/ React.createElement(Body, {
        id: id,
        variant: "small",
        className: twMerge("text-fg-error", className)
    }, children);
};

//# sourceMappingURL=ErrorMessage.js.map